import { render, staticRenderFns } from "./BedPropertyIconItem.vue?vue&type=template&id=f8fc1142&"
import script from "./BedPropertyIconItem.vue?vue&type=script&lang=js&"
export * from "./BedPropertyIconItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports